export default __webpack_public_path__ + "static/media/Inter-BlackItalic.71da97fd.woff2";